
<template>
  <div class="fund-info-page">
    <header class="fund-header">
      <button
        class="fund-back"
        type="button"
        :aria-label="$t('shopd.setshopaddr')"
        @click="$router.push('/user')"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1 class="fund-title">
        {{ $t('shopd.setshopaddr') }}
      </h1>
    </header>

    <main class="fund-content">
      <div class="fund-notice">
        <span class="fund-notice-icon"><van-icon name="shield-o" /></span>
        <p>{{ $t('d.addrtip') }}</p>
      </div>

      <div
        v-if="addr"
        class="fund-card"
      >
        <div class="fund-field">
          <label for="fund-bank">{{ $t('invest_bank.bank') }}</label>
          <input
            id="fund-bank"
            v-model="addr.curname"
            type="text"
            :placeholder="$t('invest_bank.bank')"
          >
        </div>
        <div class="fund-field">
          <label for="fund-name">{{ $t('invest_bank.name') }}</label>
          <input
            id="fund-name"
            v-model="addr.name"
            type="text"
            :placeholder="$t('invest_bank.name')"
          >
        </div>
        <div class="fund-field">
          <label for="fund-account">{{ $t('invest_bank.account') }}</label>
          <input
            id="fund-account"
            v-model="addr.tel"
            type="text"
            :placeholder="$t('invest_bank.account')"
          >
        </div>
        <div class="fund-field">
          <label for="fund-pin">{{ $t('shopd.region') }}</label>
          <div class="fund-pin-wrap">
            <input
              id="fund-pin"
              v-model="addr.region"
              maxlength="6"
              max="999999"
              size="6"
              :type="newpasswordInp"
              :placeholder="$t('shopd.region')"
              @click="write_psd = true"
            >
            <button
              class="fund-eye"
              type="button"
              :aria-label="$t('shopd.region')"
              @click="showNewsPwd"
            >
              <van-icon :name="newpasswordInp === 'text' ? 'eye-o' : 'closed-eye'" />
            </button>
          </div>
        </div>
      </div>

      <button
        v-if="show"
        class="fund-submit"
        type="button"
        @click="submitBtn"
      >
        {{ $t('shopd.ok') }}
      </button>
    </main>
    <van-popup
      v-if="show"
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              :key="i"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                x
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import {
  DropdownMenu,
  DropdownItem,
  Popup,
  PasswordInput,
  NumberKeyboard,
  Icon,
  ActionSheet
} from 'vant';

Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

export default {
  name: 'Addr',
  data() {
    return {
      show: true,
      showKeyboard: true,
      write_psd: false,
      psd_val: '',
      eye: 1,
      submitType: 1,
      newpasswordInp: 'password',
      addr: {
        name: '',
        tel: '',
        addr: '',
        curname: '',
        region: ''
      }
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    onInput(key) {
      this.psd_val = (this.psd_val + key).slice(0, 6);
      if (this.psd_val.length == 6) {
        this.write_psd = false;
        this.addr.region = this.psd_val;
      }
    },
    onDelete() {
      this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
    },
    showNewsPwd() {
      this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password';
    },
    start() {
      Fetch('/user/my_addr').then(r => {
        if (r.data && r.data.tel) {
          this.addr = r.data;
          this.show = false;
        }
      });
    },
    submitBtn() {
      if (!this.addr.tel.replace(/\s/g, '') && !this.addr.addr.replace(/\s/g, '')) {
        this.$notify(this.$t('invest_bank.accountin'));
        return;
      }
      if (this.addr.region == '123456') {
        this.$notify('출금 비밀번호가 너무 간단해요');
        return;
      }
      Fetch('/user/addr_add', {
        ...this.addr
      }).then(() => {
        this.$toast({
          background: '#07c160',
          message: 'Added Success'
        });
        this.$router.push('/user');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fund-info-page {
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 56px;
  color: #20304a;
  
}

.fund-header {
  position: relative;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ebebeb;
  background: rgba(255, 255, 255, .94);
  backdrop-filter: blur(10px);
}

.fund-back {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #26364e;
  font-size: 16px;
}

.fund-title {
  max-width: calc(100% - 100px);
  margin: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fund-content {
  box-sizing: border-box;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 16px 16px 48px;
}

.fund-notice {
  position: relative;
  display: flex;
  min-height: 82px;
  align-items: flex-start;
  gap: 12px;
  padding: 18px;
  overflow: hidden;
  border-radius: 16px;
  background: linear-gradient(125deg, #1d304d, #355678 72%, #4a617f);
  box-shadow: 0 10px 24px rgba(25, 46, 75, .18);
  color: #fff;
}

.fund-notice::after {
  position: absolute;
  top: -54px;
  right: -45px;
  width: 145px;
  height: 145px;
  border: 1px solid rgba(255, 255, 255, .17);
  border-radius: 50%;
  content: '';
  pointer-events: none;
}

.fund-notice-icon {
  z-index: 1;
  display: flex;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, .22);
  border-radius: 10px;
  color: #f5c875;
  font-size: 16px;
}

.fund-notice p {
  z-index: 1;
  min-width: 0;
  margin: 0;
  color: rgba(255, 255, 255, .9);
  font-size: 12px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.fund-card {
  margin-top: 14px;
  padding: 18px 16px;
  border: 1px solid rgba(255, 255, 255, .9);
  border-radius: 16px;
  background: rgba(255, 255, 255, .98);
  box-shadow: 0 8px 22px rgba(35, 50, 73, .08);
}

.fund-field + .fund-field {
  margin-top: 16px;
}

.fund-field label {
  display: block;
  margin-bottom: 8px;
  color: #26364e;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.fund-field > input,
.fund-pin-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 46px;
  border: 1px solid #e7e9ee;
  border-radius: 10px;
  background: #f8f9fb;
  transition: border-color .2s, background .2s;
}

.fund-field > input,
.fund-pin-wrap input {
  padding: 0 14px;
  color: #1e2d43;
  font-size: 14px;
  line-height: 44px;
  outline: 0;
}

.fund-field > input:focus,
.fund-pin-wrap:focus-within {
  border-color: #ff718a;
  background: #fff;
}

.fund-field input::placeholder {
  color: #9ba5b1;
  opacity: 1;
}

.fund-pin-wrap {
  display: flex;
  align-items: center;
}

.fund-pin-wrap input {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  height: 44px;
  border: 0;
  background: transparent;
}

.fund-eye {
  display: flex;
  flex: 0 0 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #718096;
  font-size: 16px;
}

.fund-submit {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  margin-top: 16px;
  padding: 0 12px;
  border: 0;
  border-radius: 12px;
  background: #ff385c;
  box-shadow: 0 8px 18px rgba(255, 56, 92, .2);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 48px;
  text-align: center;
}

.fund-submit:active {
  background: #e82950;
}

.fund-info-page /deep/ .van-popup--bottom {
  border-radius: 16px 16px 0 0;
  background: #f7f7f7;
}

.psw_box {
  padding-top: 28px;
}

.psw_box /deep/ .van-password-input {
  margin: 20px 20px 0;
}

.psw_box /deep/ .van-password-input__security {
  height: 48px;
  border-radius: 10px;
  overflow: hidden;
  font-size: 16px;
}

.keybord_box {
  margin-top: 20px;
  padding: 12px 8px 20px;
  background: #edf0f4;
}

.keybord {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  max-width: 420px;
  margin: 0 auto;
}

.key_item {
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff;
  color: #26364e;
  font-size: 16px;
  font-weight: 600;
}

.key_item.no_bg {
  background: transparent;
}

.key_item.x {
  color: #617187;
}

@media (max-width: 340px) {
  .fund-content {
    padding-right: 12px;
    padding-left: 12px;
  }

  .fund-card {
    padding-right: 14px;
    padding-left: 14px;
  }
}
</style>
